<template>
  <div class="leaderboard__wrapper my-4">
    <v-card flat class="grey lighten-4 mx-auto d-flex align-center" width="468" height="60">
      <v-card-text class="text-center text-overline accent--text">FULL BANNER 468 x 60</v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'FullBanner'
  }
</script>